/**
 * 
 * @param {*} value
 * @param {boolean} if false/undefined then wrap formatted price is span tag  
 * @returns 
 */

const formatCurrency = function (value, raw) {
    const settings = (HONDA && HONDA.currency) || {};
    let formattedCurrency;

    let [whole, fraction] = value.toString().split('.');
    let decimalFraction = '00';
    let isPositive = (value == Math.abs(value));

    // decimal logic interpolation
    if (fraction) {
        if (fraction.length > +settings.roundToDecimalPlace) {
            let part1 = +fraction.substring(0, +settings.roundToDecimalPlace);
            let part2 = +(fraction.substring(+settings.roundToDecimalPlace, +settings.roundToDecimalPlace+1));

            if(part2 > 5) {
                decimalFraction = (+part1 + 1).toString();
            } else {
                decimalFraction = part1;
            }
        }
    }

    // comma separation logic interpolation
    if (settings.groupDigits && whole) {
        for (var i = 0; i < Math.floor((whole.length - (1 + i)) / 3); i++) {
            whole = whole.substring(0, whole.length - (4 * i + 3)) + settings.digitGroupSymbol + whole.substring(whole.length - (4 * i + 3));
        }
    }

    // whole + fraction after interpolation
    if(whole && decimalFraction) {
        formattedCurrency = [whole, decimalFraction].join(settings.decimalSymbol);
    }
    
    // symbol + number format interpolation
    if(formattedCurrency) {
        let format = (isPositive ? settings.positiveFormat : settings.negativeFormat);
        formattedCurrency = format.replace(/%n/g, formattedCurrency);
        formattedCurrency = formattedCurrency.replace(/%s/g, settings.symbol);
    }

    return raw ? formattedCurrency : `<span>${formattedCurrency}</span>`;
};

export default formatCurrency;
